import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "hooks/redux";
import {
    getSPData,
    MdpArr,
    resetSp,
    setIsMore,
    setMDPSelectedItem,
    setPage,
    setSavedMDP,
    setSavedSP,
    removeMDPItem,
} from "store/reducers/SettingsSlice";
import InfiniteScroll from "react-infinite-scroller";
import { v4 as uuidv4 } from "uuid";
import Loader from "components/Loader/Loader";
import { NotFoundDiv } from "../CPSettingsBlock/cPSettingsBlockStyles";
import MDPSettingsItem from "./MDPSettingsItem";

import uniqWith from "lodash-es/uniqWith";
import isEqual from "lodash-es/isEqual";
import { ItemsWrapper } from "./mDPSettingsBlockStyles";

type MdpObjectType = {
    "ID.source": string;
    "Source.Type": string;
    id: string;
};
const scrollStyles = {
    backgroundColor: "#7CBE7B",
    width: "6px",
    borderRadius: "10px",
};

const default_state = {
    mdp: false,
    sp: false,
    native: false,
};

function MdpList({ isShowAll }: any) {
    const dispatch = useDispatch();
    const {
        settings,
        allSP: SP,
        savedSettings,
        nativeSP,
        error,
        MDPSelectedItem,
        from_sp,
    } = useAppSelector((state) => state.settings);
    const { MDP } = savedSettings;
    const [stateMDP, setStateMDP] = useState<Array<MdpObjectType>>();
    const [stateSP, setStateSP] = useState<Array<MdpObjectType>>();
    const [stateNative, setStateNative] = useState<Array<MdpObjectType>>();
    const [state, setState] = useState<MdpObjectType[]>([]);
    const [tickerBlocksActiveStatus, setTickerBlocksActiveStatus] = useState<
        Set<string>
    >(new Set());
    const {
        resetKey,
        mdpPage,
        searchString,
        activeTicker,
        isMore,
        totalSPPages,
    } = useAppSelector((state) => state.settings);

    const handleLoadMore = async () => {
        // if (mdpPage === 1) dispatch(resetSp());
        console.log(mdpPage, totalSPPages);

        let page = mdpPage;
        return Promise.resolve()
            .then(() => dispatch(setIsMore(false)))
            .then(() => {
                if (searchString !== "" && mdpPage !== totalSPPages) {
                    dispatch(
                        getSPData({ page, search: searchString, isSame: false })
                    );
                }
            })
            .then(() => {
                dispatch(setPage(mdpPage));
            });
    };

    const handleSettingClick = (name: string) => () => {
        const SPname = name.replace("::copy", "");

        dispatch(setMDPSelectedItem({ SPname }));
    };

    const handleCopyOfTheMDP =
        (name: string, type: string, listType: string = "MDP") =>
        () => {
            const doublingItem = {
                "ID.source": name + "::copy",
                "Source.Type": type,
                id: uuidv4(),
            };

            const searchList = listType === "MDP" ? stateMDP : stateSP;

            const isLessThanTwo =
                searchList &&
                searchList?.filter(
                    (x) =>
                        x["ID.source"].split(" ")[0] === name &&
                        x["ID.source"].includes("copy")
                ).length < 1;

            if (isLessThanTwo && listType === "MDP") {
                // @ts-ignore
                setStateMDP((prevState) => [...prevState, doublingItem]);
            } else if (isLessThanTwo && listType === "SP") {
                //@ts-ignore

                setStateSP((prevState) => [doublingItem, ...prevState]);
            }
        };

    const handleDeleteClick =
        (mdpName: string, listType: string = "MDP", sourceType: string) =>
        () => {
            if (mdpName.includes("copy")) {
                const { MDP: localMDP } = savedSettings;
                const searchList = listType === "MDP" ? stateMDP : stateSP;
                const newStateMDP = searchList?.filter(
                    (x) => x["ID.source"] !== mdpName
                );
                listType === "MDP"
                    ? setStateMDP(newStateMDP)
                    : setStateSP(newStateMDP);
                const idSourceParamIndex =
                    localMDP["params"].indexOf("ID.source");
                let valuesMDP = [...localMDP.values].filter(
                    (item) => item[idSourceParamIndex] !== mdpName
                );
                dispatch(setSavedMDP({ ...localMDP, values: valuesMDP }));
            }
        };

    const handleSelectChange = (
        value: string,
        mdpName: string,
        sourceType: string
    ) => {
        const { MDP: localMDP } = savedSettings;
        const isActiveParamIndex = localMDP["params"].indexOf("Source.Type");
        const idSourceParamIndex = localMDP["params"].indexOf("ID.source");
        // const localMDPArrIndexTest = localMDP["values"].findIndex(i => i[idSourceParamIndex].includes(mdpName.split(" ")[0]) && i.includes(sourceType))
        let localMDPArrIndex = localMDP["values"].findIndex(
            (i) => i[idSourceParamIndex] === mdpName
        );
        const newLocalValues = localMDP["values"].map((item, index) => {
            return index === localMDPArrIndex
                ? item.map((item, index) => {
                      return index === isActiveParamIndex ? value : item;
                  })
                : item;
        });
        dispatch(
            setSavedMDP({
                ...localMDP,
                values: uniqWith(newLocalValues, isEqual),
            })
        );
    };

    const handleIsActiveChange = (
        value: boolean,
        mdpName: string,
        sourceType: string
    ) => {
        // because MDP "copies" are sharing SP param, and we do not need to make a diff between them
        const SPname = mdpName.replace("::copy", "");
        const { MDP: localMDP, SP: localSP } = savedSettings;
        const isMDPinTicker =
            localMDP["values"].findIndex(
                (i) => i.includes(mdpName) && i.includes(sourceType)
            ) !== -1;
        const indexSPinTicker = localSP.findIndex(
            (arrayOfParams) => arrayOfParams[0] === SPname
        );
        const defaultMDPValues = [
            "1",
            `${activeTicker.name}~DEP~SPB`,
            mdpName.split(" ")[0],
            sourceType,
            "1",
            "0",
        ];
        if (value && !isMDPinTicker) {
            let localMDPArray = new Array(localMDP.params.length)
                .fill("")
                .map((field, index) => {
                    if (defaultMDPValues[index]) {
                        return defaultMDPValues[index];
                    }
                    return "";
                });

            if (!~indexSPinTicker) {
                const blankSPArray = SP.find(
                    (spData) => spData[0] === SPname
                )?.slice(1);
                const localSPArray = [SPname, ...blankSPArray];
                dispatch(setSavedSP([...localSP, localSPArray]));
            }

            dispatch(
                setSavedMDP({
                    ...localMDP,
                    values: [...localMDP["values"], localMDPArray],
                })
            );
        } else {
            dispatch(removeMDPItem({ mdp_name: mdpName }));
        }
    };

    useEffect(() => {
        if (MDP?.params?.length > 0) {
            const mdpItems = MDP.values.map((arr: MdpArr) => ({
                "ID.source": arr[2],
                "Source.Type": arr[3],
                id: uuidv4(),
            }));
            setStateMDP(mdpItems);
        }
    }, [MDP]);

    useEffect(() => {
        if (Array.isArray(nativeSP)) {
            const nativeItems = nativeSP
                .filter(
                    (spItem) =>
                        stateMDP?.findIndex(
                            (mdpItem) => mdpItem["ID.source"] === spItem
                        ) === -1 || stateMDP === undefined
                )
                .map((arr: any) => ({
                    "ID.source": arr as string,
                    "Source.Type": "" as string,
                    id: uuidv4() as string,
                }));
            setStateNative(nativeItems);
        }
    }, [nativeSP, stateMDP, activeTicker?.name, MDP]);

    useEffect(() => {
        if (isShowAll && SP) {
            const allsp = SP.map((spData) => spData[0])
                ?.filter(
                    (spItem) =>
                        stateMDP?.findIndex(
                            (mdpItem) => mdpItem["ID.source"] === spItem
                        ) === -1 || stateMDP === undefined
                )
                ?.filter(
                    (spItem) =>
                        stateNative?.findIndex(
                            (mdpItem) => mdpItem["ID.source"] === spItem
                        ) === -1 || stateNative === undefined
                )
                ?.map((arr: any) => ({
                    "ID.source": arr as string,
                    "Source.Type": "" as string,
                    id: uuidv4() as string,
                }));
            setStateSP([...allsp]);
            dispatch(setIsMore(true));
        } else if (!isShowAll) {
            setStateSP([]);
            dispatch(setIsMore(false));
        }
    }, [SP, isShowAll, stateMDP, searchString]);

    useEffect(() => {
        const __state = [];
        const states = [
            {
                state: stateNative,
                source: "native",
            },
            {
                state: stateMDP,
                source: "mdp",
            },
            {
                state: stateSP,
                source: "sp",
            },
        ];
        for (const item of states) {
            if (!Array.isArray(item.state)) {
                continue;
            }
            for (const state_item of item.state) {
                if (
                    !__state.some(
                        (x) => x["ID.source"] === state_item["ID.source"]
                    )
                ) {
                    __state.push({
                        ...state_item,
                        source: item.source,
                    });
                }
            }
        }

        setState(__state);
    }, [stateMDP, stateNative, stateSP, savedSettings, searchString]);

    useEffect(() => {
        setTickerBlocksActiveStatus((prev) => new Set());
        savedSettings.MDP.values.forEach((tupleOfValues) => {
            setTickerBlocksActiveStatus((prev) =>
                new Set(prev).add(tupleOfValues[2])
            );
        });
    }, [savedSettings]);

    return (
        <>
            {activeTicker.name !== "Название тикера" && (
                <ItemsWrapper
                    renderThumbVertical={(props: any) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                ...scrollStyles,
                            }}
                        />
                    )}
                >
                    {error && <NotFoundDiv>{error}</NotFoundDiv>}
                    {stateMDP?.length === 0 &&
                        stateSP?.length === 0 &&
                        stateNative?.length === 0 && (
                            <NotFoundDiv>MDP data not found</NotFoundDiv>
                        )}
                    {!error && stateMDP && (
                        <InfiniteScroll
                            data-testid="episodes-infinite-scroll"
                            pageStart={0}
                            loadMore={handleLoadMore}
                            hasMore={isShowAll && isMore}
                            loader={<Loader size="large" key={"rarekey99"} />}
                            useWindow={false}
                        >
                            {state.map((obj) => {
                                const select_condition = from_sp.includes(
                                    obj["ID.source"]
                                );

                                return (
                                    <MDPSettingsItem
                                        from_sp={from_sp}
                                        isSelected={tickerBlocksActiveStatus.has(
                                            obj["ID.source"]
                                        )}
                                        isDisabled={false}
                                        key={
                                            obj["ID.source"] +
                                            obj["Source.Type"] +
                                            obj.id +
                                            resetKey.toString()
                                        }
                                        //@ts-ignore
                                        setIsActiveMDPs={
                                            setTickerBlocksActiveStatus
                                        }
                                        isActive={tickerBlocksActiveStatus.has(
                                            obj["ID.source"]
                                        )}
                                        source={obj["ID.source"]}
                                        sourceType={obj["Source.Type"]}
                                        onSettingClick={handleSettingClick(
                                            obj["ID.source"]
                                        )}
                                        makeCopyOfTheMDP={handleCopyOfTheMDP(
                                            obj["ID.source"].split(" ")[0],
                                            ""
                                        )}
                                        onDeleteClick={handleDeleteClick(
                                            obj["ID.source"],
                                            "MDP",
                                            obj["Source.Type"]
                                        )}
                                        onSelectChange={(
                                            selectedValue: string
                                        ) =>
                                            handleSelectChange(
                                                selectedValue,
                                                obj["ID.source"],
                                                obj["Source.Type"]
                                            )
                                        }
                                        onIsActiveChange={(
                                            checkValue: boolean,
                                            explicitMDPName?: string
                                        ) =>
                                            handleIsActiveChange(
                                                checkValue,
                                                explicitMDPName ??
                                                    obj["ID.source"],
                                                obj["Source.Type"]
                                            )
                                        }
                                    />
                                );
                            })}
                        </InfiniteScroll>
                    )}
                </ItemsWrapper>
            )}
        </>
    );
}

export default MdpList;
